export var pad2 = function pad2(number) {
  if (number <= 99) {
    return ('0' + number).slice(-2);
  }

  return number;
};
export var pad3 = function pad3(number) {
  if (number <= 999) {
    return ('00' + number).slice(-3);
  }

  return number;
};
export var loadJson = function loadJson(fichero) {
  return new Promise(function (resolve, reject) {
    var src = fichero + '.json.js';

    var handleLoadError = function handleLoadError(e) {
      if (!e.filename.endsWith(src)) {
        return;
      }

      window.removeEventListener('error', handleLoadError);
      resolve({});
      return true;
    };

    window.addEventListener('error', handleLoadError);
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.addEventListener('error', function (e) {
      reject({
        message: 'Script Error: ' + src + ', ' + fichero
      });
    });
    script.addEventListener('load', function (e) {
      var key = fichero.split('/').slice(-1)[0];
      var data = void 0;

      try {
        data = window.data[key];
      } catch (e) {
        data = resolve({});
      } finally {
        window.removeEventListener('error', handleLoadError);
        resolve(data);
      }
    });
    script.src = src;
    document.head.appendChild(script);
  });
};
export var decodificarZonaId = function decodificarZonaId(zonaId) {
  return {
    libroId: zonaId.substring(0, 2),
    numPagina: Number(zonaId.substring(2, 5)),
    numZona: Number(zonaId.split('.')[1])
  };
};
export var tipoVinculo = function tipoVinculo(zona) {
  return zona.vinculo && zona.vinculo.split(',')[0] || 'zoom';
};
export function is_touch_device() {
  /*
  return 'ontouchstart' in window        // works on most browsers 
      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  */
  return 'ontouchend' in window;
}
export var getKeyImagenUsuarioPantallaLibro = function getKeyImagenUsuarioPantallaLibro(libroId, numPagina) {
  return 'dataURL-' + libroId + '-' + numPagina;
};
export var getKeyImagenUsuarioPantallaVentana = function getKeyImagenUsuarioPantallaVentana(libroId, numPagina, numZona) {
  return 'dataURL-' + libroId + '-' + numPagina + '-' + numZona;
};
var RAIZ_KEY_TEXTOS_USUARIO = 'textosUsuario';
export var getKeyTextosPagina = function getKeyTextosPagina(libroId, numPagina) {
  return [RAIZ_KEY_TEXTOS_USUARIO, libroId, numPagina].join('-');
};
export var getKeyTextosZona = function getKeyTextosZona(libroId, numPagina, numZona) {
  return getKeyTextosPagina(libroId, numPagina) + '-' + numZona;
};
var inMemoryStorage = {};
var keyStorageRoot = '';
var keyStorageSesion = null;
var titleRoot = '';
export function setKeyStorageSesion(idSesion) {
  keyStorageSesion = idSesion;
}
export function setKeyStorageRoot(keyRoot) {
  keyStorageRoot = keyRoot;
}
export function setTitleRoot(title) {
  titleRoot = title;
}

function getFullKey(key) {
  return keyStorageSesion !== null ? keyStorageSesion + ':' + keyStorageRoot + key : '' + keyStorageRoot + key;
}

export function getStorageData(key) {
  var fullKey = getFullKey(key);

  try {
    return JSON.parse(window.localStorage.getItem(fullKey));
  } catch (e) {
    return inMemoryStorage[fullKey];
  }
}
export function setStorageData(key, value) {
  var fullKey = getFullKey(key);

  try {
    window.localStorage.setItem(fullKey, JSON.stringify(value));
  } catch (e) {
    inMemoryStorage[fullKey] = value;
  }
}
export function removeStorageData(key) {
  var fullKey = getFullKey(key);

  try {
    window.localStorage.removeItem(fullKey);
  } catch (e) {
    delete inMemoryStorage[fullKey];
  }
}
export function getAllStorage(clave) {
  var values = [],
      keys = Object.keys(localStorage),
      i = keys.length;

  while (i--) {
    if (keys[i].substr(0, clave.length) === clave) {
      var contenidoLocalStorage = localStorage.getItem(keys[i]);

      if (contenidoLocalStorage !== 'null' && contenidoLocalStorage !== '[]') {
        values.push(keys[i]);
        values.push(contenidoLocalStorage);
      }
    }
  }

  return values;
}
export function removeAllStorage(clave) {
  var keys = Object.keys(localStorage),
      i = keys.length;

  while (i--) {
    if (keys[i].substr(0, clave.length) === clave) {
      window.localStorage.removeItem(keys[i]);
    }
  }
}
var inMemorySessionStorage = {};

function crearSessionStorage() {
  try {
    return window.sessionStorage;
  } catch (e) {
    return {
      getItem: function getItem(key) {
        return inMemorySessionStorage[key];
      },
      setItem: function setItem(key, item) {
        return inMemorySessionStorage[key] = item;
      }
    };
  }
}

export var sessionStorage = crearSessionStorage();
export function fetch(file) {
  if (window[file]) {
    var response = {
      json: function json() {
        return window[file];
      }
    };
    return Promise.resolve(response);
  }

  return window.fetch(file);
}
/** 
 * IndexedDB para sustituir localStorage, de forma que todo funcione offline
 * 
 * https://w3c.github.io/IndexedDB/
 * */

export function confirm(mensaje) {
  var tituloDialogo = '' + titleRoot;
  var botones = ['OK', 'Cancel'];

  if (window.electronContext && window.dialogo) {
    var response = window.dialogo(tituloDialogo, mensaje, botones);
    return response === 0;
  } else if (window.parent.electronContext && window.parent.dialogo) {
    var _response = window.parent.dialogo(tituloDialogo, mensaje, botones);

    return _response === 0;
  } else {
    return window.confirm(mensaje);
  }
}
export function alert(mensaje) {
  var tituloDialogo = '' + titleRoot;

  if (window.electronContext && window.alerta) {
    window.alerta(tituloDialogo, mensaje);
  } else if (window.parent.electronContext && window.parent.alerta) {
    window.parent.alerta(tituloDialogo, mensaje);
  } else {
    window.alert(mensaje);
  }
}